import { Component, Injector } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { BaseClass } from '../../utility/baseClass';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrganisationService } from '../../main-layout/organisation/organisation.service';

@Component({
  selector: 'app-organisationbusinessusermodal',
  templateUrl: './organisationbusinessusermodal.component.html',
  styleUrls: ['./organisationbusinessusermodal.component.css']
})
export class OrganisationbusinessusermodalComponent extends BaseClass{
existingdetails:any
    OrganisationForm: FormGroup;
    orgid:any;
      yesnolist=[
    {label:'Yes',value:'Y'},
    {label:'No',value:'N'}
  ]
  constructor(public override injector: Injector,private fb:FormBuilder ,private utilityservice:Utilityservice,
    public ref: DynamicDialogRef, private spinnerservice:NgxSpinnerService, private orgservice:OrganisationService,
    public config: DynamicDialogConfig,
  ){
  super(injector);
  this.gettoken();
    const datafromparent=this.config.data;
  this.orgid=datafromparent.orgid;
      this.existingdetails = datafromparent.datas;
    this.formInitial();
    this.patchValue(this.existingdetails);


  }
  public validation_message = {
    'orgname': [{ type: 'required', message: 'Organisation is required' }],
    'address': [{ type: 'required', message: 'Address is required' }],
    'noofcompany':[{type:'required',message:'No of entity is required'}],
    'noofuser':[{}],
    'nooflocation':[{type:'required',message:'No of location is required'}],
        'nooftraining':[{type:'required',message:'No of training is required'}],
    'spaceallowed':[{type:'required',message:'Space allowed is required'}],
    'dataservice':[{type:'required',message:'Data service is required'}],
    'databackupdownloadflag':[{type:'required',message:'Data Backup is Required'}],
    'issuspended':[{type:'required',message:'Suspended is Required'}],

    

  }
  formInitial(){
    this.OrganisationForm= this.fb.group({
      orgname:['',Validators.required],   
      noofcompany: ['',Validators.required],
      noofuser: ['',Validators.required],
      nooflocation: ['',Validators.required],
      dataservice:['',Validators.required],
      requirebusinessuser:['',Validators.required],
      spaceallowed:['',Validators.required],
      nooftraining:['',Validators.required],
      noofbuser:['',Validators.required],
      issuspended:['',Validators.required],
      databackupdownloadflag:['Y'],
  
      })
    }
    CSRFToken=''
      gettoken(){
        this.CSRFToken='';
         this.utilityservice.getCSRFtoken().subscribe(res=>{
         this.CSRFToken=res.csrf;
        },error=>{
          Swal.fire(error.error.message,'','error');
        });
      }

        modify(){ 
          let previousdata=this.existingdetails;
          console.log(previousdata,"previousdata");
          
          if(this.OrganisationForm.invalid){
            this.validateAllFormFields(this.OrganisationForm);
          }else{
          Swal.fire({
                title: "Do you want to save the changes?",
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: "Save",
                denyButtonText: `Don't save`
              }).then((value) => {
                if (value.isConfirmed) {
                
      
        let data={
           "bd_orgname":this.OrganisationForm.value.orgname,
          "bd_noofcompany":this.OrganisationForm.value.noofcompany,
          "bd_noofuser":this.OrganisationForm.value.noofuser,
          "bd_nooflocation":this.OrganisationForm.value.nooflocation,
          "bd_requirebusinessuser":this.OrganisationForm.value.requirebusinessuser,          
          "bd_spaceallowed":this.OrganisationForm.value.spaceallowed,
          "bd_nooftraining":this.OrganisationForm.value.nooftraining,
          "bd_noofbuser":this.OrganisationForm.value.noofbuser,
           "bd_databackupdownloadflag":this.OrganisationForm.value.databackupdownloadflag,
          "csrftoken":this.CSRFToken,
          "bd_issuspended":this.OrganisationForm.value.issuspended,
    "bd_prev_issuspended":previousdata.issuspended,
    "bd_prev_noofspace":previousdata.spaceallowed,
    "bd_prev_noofentity":this.existingdetails.noofcompany,
    "bd_prev_nooflocation":previousdata.nooflocation,
    "bd_prev_noofuser":previousdata.noofuser,
    "bd_prev_nooftraining":previousdata.nooftraining,
    "bd_prev_noofbusers":previousdata.requirebusinessusers,
    "orgid":this.orgid,
    "bd_id":this.orgid
    // "bd_prev_noofbusers":previousdata.noofbusinessusers,
         }
         
                   
                        this.spinnerservice.show();
                  this.orgservice.modifybduser(data).subscribe(() => {
                        this.spinnerservice.hide()
                    Swal.fire("Saved!", "", "success").then(() => {
                      this.ref.close();
                    });
                  }, error => {
                        this.spinnerservice.hide();
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: error.error.error,
                      footer: "error status is :" + ' ' + error.status
                    });
                  });
                  
              
                } else if (value.isDenied) {
                  Swal.fire("Changes are not saved", "", "info");
                }
              });      
          }  
        }
        getPreviousData(){

        }
patchValue(data){
  console.log(data,"data");
  this.OrganisationForm.patchValue({orgname:data.name,
    address:data.address,
    city:data.city,
    country:data.country,
    addressstate:data.state,
    dataservice:data.dataservice,
    phone:data.phone,
    pin:data.pin,
    orgtype:data.orgtype,
    spaceallowed:data.spaceallowed,
    orginitial:data.orginitial,
    noofcompany:data.noofcompany,
    nooflocation:data.nooflocation,
    noofuser:data.noofuser,
    nooftraining:data.nooftraining,
    esign:data.esignflag,
    isenterprise:data.enterprise,
    requirebusinessuser:data.requirebusinessusers,
    noofbuser:data.noofbusinessusers,
    authtype:data.authenticationtype
                  
  })
  


}
}
